import { BaseResource } from '../core/base-resource';

export class PasswordUpdateData extends BaseResource {
  password: string;
  passwordConfirmation: string;
  previousPassword: string;
}
